import { createThunk, ThunkDispatch } from '../../shared';
import { persistPeopleHubOptions } from '../dataLayer/ows/persistPeopleHubOptions';
import type { PeopleHubOptions } from '../models/peopleHubOptions';
import { AppState, getAppState } from '../state';
import debounce from 'lodash-es/debounce';

const PERSIST_DATA_DEBOUNCE_TIME = 10000; // 10 seconds

export const debouncedSerializeAndPersistPeopleHubOptions = debounce(
    dispatch => dispatch(serializeAndPersistPeopleHubOptions)(),
    PERSIST_DATA_DEBOUNCE_TIME,
    { trailing: true }
);

export const serializeAndPersistPeopleHubOptions = createThunk(
    'SerializeAndPersistPeopleHubOptions',
    (dispatch: ThunkDispatch, getState: () => {}) => () => {
        const peopleHubOptionsString = JSON.stringify(getPeopleHubOptions(getAppState(getState())));
        persistPeopleHubOptions(peopleHubOptionsString).catch(error => {
            // Catch promise rejection so it doesn't bubble up
        });
    }
);

function getPeopleHubOptions(appState: AppState): PeopleHubOptions {
    const layoutState = appState.view.layoutState;
    return {
        searchHistory: appState.data.searchState.searchHistory,
        personaMRU: appState.data.searchState.personaMRU,
        displayOrder: layoutState.displayOrder,
        filter: layoutState.filter,
        isLeftNavVisible: layoutState.isLeftNavVisible,
        leftPaneWidth: layoutState.leftPaneWidth,
        listWidth: layoutState.listWidth,
        sorting: layoutState.sorting,
        deletedItemsSorting: layoutState.deletedItemsSorting,
        contactListsSorting: layoutState.contactListsSorting,
        isCAPIv3Enabled: layoutState.isCAPIv3Enabled,
    };
}
export type { Action } from '../../shared';
